<template>
  <v-snackbar
    v-model="snackbarVisible"
    :color="snackbarColor"
    :timeout="snackbarTimeout"
    location="bottom right"
    @click="handleClick"
  >
    {{ snackbarMessage }}
    <template #actions>
      <v-btn variant="text" icon="close" @click.stop="close" />
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
import { useSnackbar } from '../composables/ui/useSnackbar'

const { snackbarVisible, snackbarMessage, snackbarColor, snackbarTimeout, close, handleClick } = useSnackbar()
</script>
